import { h, Component } from "preact";
import { connect } from "react-redux";
import { css } from "emotion";
import config from "../config";

import YouTubeVideo from "./YouTubeVideo";
import Share from "./Share";
import Button from "./Button";
import ButtonRow from "./ButtonRow";
import Smile from "../assets/images/logos/faces/simle";

const websiteUrl = config("WEBSITE_URL");

const Thankyou = ({ event, order, showCharity = true }) => {
  const wrapper = css({
    maxWidth: 800,
    width: "100%",
    backgroundColor: "#FFF",
    margin: "0 auto",
    borderRadius: 4,
    padding: "32px 12px",
    textAlign: "center",
    boxShadow: "0 1px 10px 0 rgba(32, 7, 64, 0.13)",
    marginBottom: 14,
    "@media(max-width: 800px)": {
      padding: "24px 12px"
    }
  });
  const heading = css({
    marginBottom: 8
  });
  const paragraph = css({
    marginBottom: 24
  });

  const youtube = css({
    width: 400,
    height: 225,
    borderRadius: 4,
    boxShadow: "2px 2px 10px 2px rgba(56, 66, 9, 0.13)",
    marginBottom: 24,
    "@media(max-width: 800px)": {
      width: 268,
      height: 151
    }
  });
  let visualElement = (
    <img
      src={event.data.charity.logo.url}
      style={{
        borderRadius: 4,
        boxShadow: "2px 2px 10px 2px rgba(56, 66, 9, 0.13)",
        marginBottom: 24,
        maxWidth: 200
      }}
    />
  );

  if (event.data.charity.video) {
    visualElement = (
      <YouTubeVideo code={event.data.charity.video} style={youtube} />
    );
  }
  const primaryColor =
    event.data.theme && event.data.theme.primaryColor
      ? event.data.theme.primaryColor
      : "#6621c0";
  const title = showCharity
    ? `Thank you ${order.data.firstName} for making a difference!`
    : `Thanks for your purchase, ${order.data.firstName}!`;
  const smileWidth = showCharity ? 60 : 80;

  return (
    <div class={wrapper}>
      <Smile
        color={primaryColor}
        style={{ width: smileWidth, marginBottom: 12 }}
      />
      <h1 className={heading}>{title}</h1>
      {showCharity ? (
        <div>
          <p className={paragraph}>
            Humanitix is donating 100% of booking fee profits to{" "}
            {event.data.charity.partnered
              ? event.data.charity.name.toLowerCase()
              : event.data.charity.name}
          </p>
          {visualElement}
          <div>
            <ButtonRow>
              <Button
                link={
                  event.data.charity.projectPageUrl
                    ? `${websiteUrl}${event.data.charity.projectPageUrl}`
                    : event.data.charity.website
                }
                type="secondary"
              >
                Learn More
              </Button>
              <Share
                eventLink={`${config("TICKETING_URL")}/${event.data.slug}`}
                icon={false}
              />
            </ButtonRow>
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default connect(
  state => ({
    event: state.event,
    order: state.order
  }),
  {}
)(Thankyou);



// WEBPACK FOOTER //
// ./components/Thankyou.js